<template>
  <div>
    <h4 class="tab__content__title">Основная информация</h4>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.PROJECT_NAME }}:</span>
      <span class="stack__value break-words">{{ application.name }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.ADDITIONAL_EXPERTISE }}:</span>
      <span class="stack__value">{{application.additionalExpertise.map((item) => $lang.$translate({ ru: item.nameRu, kg: item.nameKg })).join(", ") }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.CONSTRUCTION_TYPE }}:</span>
      <span class="stack__value">{{ $lang.$translate({ ru: application.constructionType?.nameRu, kg: application.constructionType?.nameKg }) }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.PURPOSE_OF_OBJECT }}:</span>
      <span class="stack__value">{{ $lang.$translate({ ru: application.appointment?.nameRu, kg: application.appointment?.nameKg }) }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.OBJECT_POSTAL_ADDRESS }}:</span>
      <span class="stack__value">{{ application.address?.address }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.EXPERTIZE_PAYMENT_SOURCE }}:</span>
      <span class="stack__value">{{ application.paymentSourceTxt }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.OWNERSHIP_FORM }}:</span>
      <span class="stack__value">{{ $lang.app[ownershipTypesGetLabelRefByValue(application.ownership)] }}</span>
    </div>
    <template v-if="application.locationType">
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.OBJECT_CATEGORY }}:</span>
        <span class="stack__value">{{ $lang.$translate({ru: application.locationType.category.nameRu, kg: application.locationType.category.nameKg}) }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.OBJECT_TYPE }}:</span>
        <span class="stack__value">{{ $lang.$translate({ru: application.locationType.nameRu, kg: application.locationType.nameKg}) }}</span>
      </div>
    </template>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.OBJECT_IS_STRATEGIC }}</span>
      <span class="stack__value">{{ application.isStrategic ? $lang.app.YES : $lang.app.NO }}</span>
    </div>

    <div v-for="(economicIndicator, index) in application.economicIndicators" :key="index"
         class="my-4">
      <h4 class="tab__content__title">{{ $lang.app.MAIN_TECHNO_ECONOMIC_INDICATORS_OF_OBJECT }}</h4>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.DENOMINATION }}</span>
        <span class="stack__value">{{ economicIndicator.name }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.UNIT_OF_MEASUREMENT }}</span>
        <span class="stack__value">{{ economicIndicator.unitOfMeasurement?.name }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.VALUE }}</span>
        <span class="stack__value">{{ economicIndicator.value }}</span>
      </div>
    </div>

    <div v-if="application.applicants.length">

      <div v-for="(applicant, index) in application.applicants" :key="index"
           class="my-4">
        <h4 class="tab__content__title">{{ $lang.app.APPLICANT_INFORMATION }}</h4>

        <div v-if="applicant.user?.userInfo?.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')">

          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.SURNAME }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.person?.surname }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.NAME }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.person?.name }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.person?.patronymic }}</span>
          </div>

        </div>

        <div v-if="applicant.user?.userInfo?.type === userTypesGetValueByKey('LEGAL_ENTITY')">

          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_NAME_KG }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.organization?.nameKg }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_CHIEF_SURNAME }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.organization?.surname }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_CHIEF_NAME }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.organization?.name }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_CHIEF_PATRONYMIC }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.organization?.patronymic }}</span>
          </div>

        </div>

        <div v-if="applicant.user?.userInfo?.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')">

          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.SURNAME }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.individualEnterprise?.surname }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.NAME }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.individualEnterprise?.name }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
            <span class="stack__value">{{ applicant.user?.userInfo?.individualEnterprise?.patronymic }}</span>
          </div>

        </div>

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PHONE }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.contactDetail?.phone }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.EMAIL }}</span>
          <span class="stack__value">{{ applicant.user?.userInfo?.contactDetail?.email }}</span>
        </div>

        <div v-for="(certifyingDocument, index) in applicant.certifyingDocuments" :key="index" class="my-4">

          <h4 class="tab__content__title">{{ $lang.app.CERTIFYING_ESTABLISHING_DOCUMENTS }}</h4>

          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.TYPE }}</span>
            <span class="stack__value">{{ $lang.app[certifyingDocumentTypesGetLabelRefByValue(certifyingDocument.type)] }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.DENOMINATION }}</span>
            <span class="stack__value">{{ certifyingDocument.name }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.NUMBER }}</span>
            <span class="stack__value">{{ certifyingDocument.number }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.DATE }}</span>
            <span class="stack__value">{{ $moment(certifyingDocument.docDate).format("DD.MM.YYYY") }}</span>
          </div>
          <div v-if="certifyingDocument.file" class="stack__list">
            <span class="stack__label">{{ $lang.app.FILE }}</span>
            <span class="stack__value cursor-pointer font-medium text-blue-600"
                  @click="$emitter.emit('open-employee-application-pdf-file', certifyingDocument.file)">{{ certifyingDocument.file.filename }}</span>
          </div>

        </div>

      </div>

    </div>

    <div v-if="application.customers.length">

      <div v-for="(customer, index) in application.customers" :key="index"
           class="my-4">
        <h4 class="tab__content__title">{{ $lang.app.CUSTOMER_INFORMATION }}</h4>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.CUSTOMER_OWNER }}</span>
          <span class="stack__value">{{ customer.isOwner ? $lang.app.YES : $lang.app.NO }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.MAIN_CUSTOMER }}</span>
          <span class="stack__value">{{ customer.main ? $lang.app.YES : $lang.app.NO }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.TYPE }}</span>
          <span class="stack__value">{{ $lang.app[userTypesGetLabelRefByValue(customer.type)] }}</span>
        </div>



        <div v-if="(customer.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')
          || customer.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')) && customer.person">

          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.PIN }}</span>
            <span class="stack__value">{{ customer.person.pin }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.SURNAME }}</span>
            <span class="stack__value">{{ customer.person.surname }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.NAME }}</span>
            <span class="stack__value">{{ customer.person.name }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
            <span class="stack__value">{{ customer.person.patronymic }}</span>
          </div>

        </div>

        <div v-if="customer.type === userTypesGetValueByKey('LEGAL_ENTITY') && customer.organization">

          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.INN }}</span>
            <span class="stack__value">{{ customer.organization.inn }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.MAIN_CUSTOMER }}</span>
            <span class="stack__value">{{ customer.main ? $lang.app.YES : $lang.app.NO }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_NAME_RU }}</span>
            <span class="stack__value">{{ customer.organization.nameRu }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_CHIEF_SURNAME }}</span>
            <span class="stack__value">{{ customer.organization.surname }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_CHIEF_NAME }}</span>
            <span class="stack__value">{{ customer.organization.name }}</span>
          </div>
          <div class="stack__list">
            <span class="stack__label">{{ $lang.app.ORG_CHIEF_PATRONYMIC }}</span>
            <span class="stack__value">{{ customer.organization.patronymic }}</span>
          </div>

        </div>

        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PHONE }}</span>
          <span class="stack__value">{{ customer.contactDetail?.phone }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.WORK_PHONE }}</span>
          <span class="stack__value">{{ customer.contactDetail?.phoneWork }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.EMAIL }}</span>
          <span class="stack__value">{{ customer.contactDetail?.email }}</span>
        </div>

      </div>

    </div>

    <div v-if="application.certifyingDocuments.length">

      <div v-for="(certifyingDocument, index) in application.certifyingDocuments" :key="index"
           class="my-4">
        <h4 class="tab__content__title">{{ $lang.app.CERTIFYING_ESTABLISHING_DOCUMENTS }}</h4>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.TYPE }}</span>
          <span class="stack__value">{{ $lang.app[certifyingDocumentTypesGetLabelRefByValue(certifyingDocument.type)] }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.DENOMINATION }}</span>
          <span class="stack__value">{{ certifyingDocument.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NUMBER }}</span>
          <span class="stack__value">{{ certifyingDocument.number }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.DATE }}</span>
          <span class="stack__value">{{ $moment(certifyingDocument.docDate).format("DD.MM.YYYY") }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.FILE }}</span>
          <span class="stack__value cursor-pointer text-blue-500"
                @click="$emitter.emit('open-employee-application-pdf-file', certifyingDocument.file)">{{ certifyingDocument.file.filename }}</span>
        </div>
      </div>

    </div>

    <div v-for="projectDeveloper in application.projectDevelopers"
         :key="projectDeveloper.id"
         class="my-4">
      <h4 class="tab__content__title">{{ $lang.app.PLANNER_INFORMATION }}</h4>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.TYPE }}</span>
        <span class="stack__value">{{ $lang.app[userTypesGetLabelRefByValue(projectDeveloper.type)] }}</span>
      </div>

      <div v-if="projectDeveloper.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')
        || projectDeveloper.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')">
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PIN }}</span>
          <span class="stack__value">{{ projectDeveloper.person?.pin }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.SURNAME }}</span>
          <span class="stack__value">{{ projectDeveloper.person?.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NAME }}</span>
          <span class="stack__value">{{ projectDeveloper.person?.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
          <span class="stack__value">{{ projectDeveloper.person?.patronymic }}</span>
        </div>
      </div>

      <div v-if="projectDeveloper.type === userTypesGetValueByKey('LEGAL_ENTITY')">
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.INN }}</span>
          <span class="stack__value">{{ projectDeveloper.organization?.inn }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_NAME_KG }}</span>
          <span class="stack__value">{{ projectDeveloper.organization?.nameKg }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_NAME_RU }}</span>
          <span class="stack__value">{{ projectDeveloper.organization?.nameRu }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_SURNAME }}</span>
          <span class="stack__value">{{ projectDeveloper.organization?.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_NAME }}</span>
          <span class="stack__value">{{ projectDeveloper.organization?.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.ORG_CHIEF_PATRONYMIC }}</span>
          <span class="stack__value">{{ projectDeveloper.organization?.patronymic }}</span>
        </div>
      </div>

      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER }}</span>
        <span class="stack__value">{{ projectDeveloper.certNumber }}</span>
      </div>
      <div v-if="projectDeveloper.files" class="stack__list">
        <span class="stack__label">{{ $lang.app.FILE_CERTIFICATE_LICENSES }}</span>
        <span class="stack__value cursor-pointer"
              @click="loadProjectDeveloperFile(projectDeveloper, projectDeveloper.files)">{{ projectDeveloper.files.filename }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.PHONE }}</span>
        <span class="stack__value">{{ projectDeveloper.phoneNumber }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.EMAIL }}</span>
        <span class="stack__value">{{ projectDeveloper.email }}</span>
      </div>

      <div v-for="architect in projectDeveloper.projectArchitects"
           :key="architect.id"
           class="my-4">

        <h4 class="tab__content__title">{{ $lang.app.PROJECT_MAIN_ARCHITECT }}</h4>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.SURNAME }}</span>
          <span class="stack__value">{{ architect.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NAME }}</span>
          <span class="stack__value">{{ architect.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
          <span class="stack__value">{{ architect.patronymic }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER }}</span>
          <span class="stack__value">{{ architect.certNumber }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PHONE }}</span>
          <span class="stack__value">{{ architect.phoneNumber }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.EMAIL }}</span>
          <span class="stack__value">{{ architect.email }}</span>
        </div>
      </div>

      <div v-for="engineer in projectDeveloper.projectEngineers"
           :key="engineer.id"
           class="my-4">
        <h4 class="tab__content__title">{{ $lang.app.PROJECT_MAIN_ENGINEER }}</h4>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.SURNAME }}</span>
          <span class="stack__value">{{ engineer.surname }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.NAME }}</span>
          <span class="stack__value">{{ engineer.name }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PATRONYMIC }}</span>
          <span class="stack__value">{{ engineer.patronymic }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.CERTIFICATE_NUMBER }}</span>
          <span class="stack__value">{{ engineer.certNumber }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.PHONE }}</span>
          <span class="stack__value">{{ engineer.phoneNumber }}</span>
        </div>
        <div class="stack__list">
          <span class="stack__label">{{ $lang.app.EMAIL }}</span>
          <span class="stack__value">{{ engineer.email }}</span>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {getLabelRefByValue as ownershipTypesGetLabelRefByValue} from "../../../helpers/constants/ownershipTypes";
import {
  getValueByKey as userTypesGetValueByKey,
  getLabelRefByValue as userTypesGetLabelRefByValue,
} from "../../../helpers/constants/userTypes";
import {
  getLabelRefByValue as certifyingDocumentTypesGetLabelRefByValue,
} from "../../../helpers/constants/certifyingDocumentTypes";
import applicationApi from "../../../api/employee/application";

export default {
  props: {
    application: Object
  },
  methods: {
    ownershipTypesGetLabelRefByValue,
    userTypesGetValueByKey,
    userTypesGetLabelRefByValue,
    certifyingDocumentTypesGetLabelRefByValue,
    loadProjectDeveloperFile(projectDeveloper, file) {
      this.$emitter.emit('open-loader-modal')
      applicationApi
          .getProjectDeveloperFile(this.application.id, projectDeveloper.id, file.id)
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
  }
}
</script>
